/**
 * Created by Jerker Nord on 2019-04-12.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ThorGameConfig} from "../../ThorGameConfig";
import {TextureHelper} from "../../bezieranimation/TextureHelper";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {AnimatedMeshRope} from "../../bezieranimation/AnimatedMeshRope";
import {TimelineLite} from "gsap";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";

export class ThorScatterNudgeWPView extends BaseView {

    private _layer:ScalableLayer;
    private _fixedTextures:PIXI.Texture[];
    private _animatedScatterEnergy01:AnimatedMeshRope;
    private _animatedScatterEnergy02:AnimatedMeshRope;
    private _animatedScatterEnergy03:AnimatedMeshRope;
    private _animatedScatterEnergy04:AnimatedMeshRope;
    private _animatedScatterEnergy05:AnimatedMeshRope;
    private _animatedScatterEnergys:AnimatedMeshRope[] = [];
    private _energyEndPointMeter:number[] = [320, 50];
    private _energyEndPointExtraFS:number[] = [450, 50];

    constructor() {
        super();
        this._layer = StageManager.getLayer(ThorGameConfig.instance.LAYERS.BIG_WIN.name);
        this._layer.addChild(this);
    }

    protected initAnimations():void {
        this._fixedTextures = TextureHelper.removeBaseTextures(GameResources.getTextures("scatterEnergy"));
        this._animatedScatterEnergy01 = new AnimatedMeshRope();
        this.addChild(this._animatedScatterEnergy01);
        this._animatedScatterEnergys.push(this._animatedScatterEnergy01);
        this._animatedScatterEnergy02 = new AnimatedMeshRope();
        this.addChild(this._animatedScatterEnergy02);
        this._animatedScatterEnergys.push(this._animatedScatterEnergy02);
        this._animatedScatterEnergy03 = new AnimatedMeshRope();
        this.addChild(this._animatedScatterEnergy03);
        this._animatedScatterEnergys.push(this._animatedScatterEnergy03);
        this._animatedScatterEnergy04 = new AnimatedMeshRope();
        this.addChild(this._animatedScatterEnergy04);
        this._animatedScatterEnergys.push(this._animatedScatterEnergy04);
        this._animatedScatterEnergy05 = new AnimatedMeshRope();
        this.addChild(this._animatedScatterEnergy05);
        this._animatedScatterEnergys.push(this._animatedScatterEnergy05);
    }

    public setScatterEnergyCurvePoints(reelId:number, curvePoints:number[][]):void {
        this._animatedScatterEnergys[reelId].createAnimatedMeshRope(this._fixedTextures, curvePoints);
    }

    public getScatterEnergyTL(reelId:number, symbolPosition:number, isExtraFS:boolean):TimelineLite {
        const energyStartPoint:[number, number] = Helper.getSymbolPositions(reelId, symbolPosition);
        const energyMidPoint:[number, number] = [(energyStartPoint[0] / 2), (energyStartPoint[1] / 2)];
        let energyEndPoint:number[];
        //Adjust the start of energy
        if (symbolPosition > 1){
            energyStartPoint[1] += 100;
        }else{
            energyStartPoint[1] -= 100;
        }
        if(isExtraFS == true) {
            energyEndPoint = this._energyEndPointExtraFS;
        } else {
            energyEndPoint = this._energyEndPointMeter;
        }
        this.setScatterEnergyCurvePoints(reelId, [energyStartPoint, [energyStartPoint[0], energyStartPoint[1] - this.getEnergyRandomYPos(symbolPosition)],
            [energyStartPoint[0] + this.getRandomValue(20, 60), energyStartPoint[1] - ((this.getEnergyRandomYPos(symbolPosition) + 100))], energyEndPoint]);
        return this._animatedScatterEnergys[reelId].getAnimatedMeshRopeTL();
    }

    private getEnergyRandomYPos(scatterSymbolPosition:number):number {
        if(scatterSymbolPosition > 1) {
            return MathHelper.randomIntInRange(150, 200);
        }
        return 0 - MathHelper.randomIntInRange(150, 200);
    }

    private getRandomValue(lowValue:number, highValue:number):number {
        if(MathHelper.randomIntInRange(0, 1) > 0) {
            return MathHelper.randomIntInRange(lowValue, highValue);
        } else {
            return 0 - (MathHelper.randomIntInRange(lowValue, highValue));
        }
    }
}